module.exports = __webpack_public_path__ + "img/wave.743ed91d.svg";